import styled from 'styled-components'
import RetiredPctChart from '../RetiredPctChart'
import RatioChart from '../RatioChart'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Small } from '../../theme/styles'

const DependanceCharts = () => {
  return (
    <Container>
      <Charts>
        <Column>
          <ChartHead>
            <Title>Le rapport de dépendance des personnes âgées augmente</Title>
            <Lead>
              La pression économique exercée par les seniors sur la population
              active, qui est à l'origine du bien-être économique et assure la
              majorité des entrées fiscales, ne cesse d'augmenter.
            </Lead>
          </ChartHead>
          <RetiredPctChart year={2024} />
          <div>
            {' '}
            <Small>
              <strong>Source</strong>: Office fédéral de la statistique
            </Small>
          </div>
        </Column>
        <Column>
          <ChartHead>
            <Title>Toujours moins d'actifs pour un retraité</Title>
            <Lead>
              Le statut d'activité de la population montre un autre visage de la
              dépendance des retraités à la population active. Ces données,
              qui courent de 1991 à 2022, révèlent une diminution du nombre
              d'actifs pour un retraité.
            </Lead>
          </ChartHead>
          <RatioChart year={2024} />
          <div>
            <Small>
              Statut d'activité de la population résidante permanente selon les
              groupes d'âge d'après l'enquête suisse sur la population active
              (ESPA).
            </Small>
          </div>
          <Small>
            <strong>Source</strong>: Office fédéral de la statistique
          </Small>
        </Column>
      </Charts>
    </Container>
  )
}

const Container = styled.div`
  margin: 60px auto;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin: 45px auto;
  }
`

const Charts = styled.div`
  column-count: 2;
  column-gap: 20px;
  max-width: 1400px;
  margin: auto;

  ${({ theme }) => theme.breakpoints.down('xxl')} {
    margin: 0 15px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    column-count: 1;
    margin: 0 15px;
  }
`

const Column = styled.div`
  break-inside: avoid;
  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 40px;

    &:first-child {
      margin-top: 0px;
    }
  }
`

const ChartHead = styled.div`
  margin-bottom: 2em;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.85em;
  }
`

const Title = styled.div`
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: 0.35em;
`

const Lead = styled.div`
  line-height: 1.4;
`

export default DependanceCharts
